export default __webpack_public_path__ + "static/media/code.1e666016.jpg";